import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailPurseStringWrinkle({data, img}) {
    return (
        <MeasurementResult type="팔자주름" description='"팔자 주름"은 입술 주위에 형성되는 주름을 가리킵니다. 이 주름은 입술 주위에 위치하고, 주로 입술 주변의 표정 움직임이나 표정 표현에 의해 형성됩니다. 팔자 주름은 피부의 탄력이 감소하거나 노화에 따라 깊어질 수 있습니다.' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        {
                        img.image_cross_polar_front &&
                        <img src={img.image_cross_polar_front} />
                        }
                        {
                        img.image_mark_nasolabial_folds_front &&
                        <img src={img.image_mark_nasolabial_folds_front} />
                        }

                        <div className="caption">2D</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <DegreeSection 
                    type="팔자주름"
                    badge={data.analysisBadge}
                    items={[
                    {
                        value: "없음",
                        label: "0"
                    },
                    {
                        value: "경도",
                        label: "1"
                    },
                    {
                        value: "경도",
                        label: "2"
                    },
                    {
                        value: "경도",
                        label: "3"
                    },
                    {
                        value: "중간 정도",
                        label: "4"
                    },
                    {
                        value: "중간 정도",
                        label: "5"
                    },
                    {
                        value: "중증 정도",
                        label: "6"
                    },
                    {
                        value: "중증 정도",
                        label: "7"
                    },
                ]}
                text={data.degreeText}
                levelFloat={data.levelFloat}
                line={2}
                />
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult}
                />
            </div>
        </MeasurementResult>
    )
}